import { useMemo } from "react";
import { locById, useLang } from "@/lib/i18n";
import { ROOMS_TR } from "@/data/i18n/content";

const HALL_Z = 0.7;

export const ROOMS = [
  {
    id: "social", num: "00", name: "Área Social", title: "El Vestíbulo", dims: "7 m × 6 m", area: 42, color: "#7BC74D",
    img: "/img/social.webp", rect: { x: 0, z: 0, w: 7, d: 6 }, label: [56, 35],
    view: { pos: [6.3, 1.6, 1.4], yaw: (Math.PI * 2) / 3 }, pin: [3.8, 2.3, 3.1],
    summary: "El punto de partida. Bajas la escalera y el ruido de la calle se queda arriba.",
    body: "Al pie de la escalera te recibe el gran emblema de la casa. En la pared del fondo está la cafetería; entre ambas, dos mesas pequeñas y un sofá para dos personas. Bajo la escalera, una puerta da acceso a la bodega. Desde aquí nace el pasillo de arcos que conecta todas las salas.",
    items: ["Escalera de acceso con descanso", "Cafetería en la pared del fondo", "Dos mesas pequeñas y un sofá para dos", "Bodega bajo la escalera", "Emblema mural TORTUGAS"],
  },
  {
    id: "donatello", num: "01", name: "Sala Donatello", title: "La Guarida", dims: "5 m × 3 m", area: 15, color: "#A98BF5",
    img: "/img/donatello.webp", rect: { x: 7, z: 3, w: 5, d: 3 },
    view: { pos: [9.5, 1.6, HALL_Z], yaw: Math.PI }, pin: [9.5, 2.2, 4.5],
    summary: "Una habitación de fan: cama con sábanas de tortugas, repisas llenas de figuras y una tele clásica verde.",
    body: "Al fondo, una cortina simula la ventana del cuarto, rodeada de repisas con figuras de las tortugas y sus personajes. A un lado, el clóset con camisas y una cajonera cubierta de tecnología retro, juguetes y cómics. Frente a la cama, en la esquina del arco, un televisor clásico verde.",
    items: ["Cama individual con sábanas de tortugas", "Cortina-ventana de 1 m", "Repisas de figuras y pósters", "Clóset y cajonera con cómics y tecnología", "Televisor clásico verde"],
  },
  {
    id: "leonardo", num: "02", name: "Sala Leonardo", title: "El Laboratorio", dims: "5 m × 3 m", area: 15, color: "#5B9BF8",
    img: "/img/leonardo.webp", rect: { x: 12, z: 3, w: 5, d: 3 },
    view: { pos: [14.5, 1.6, HALL_Z], yaw: Math.PI }, pin: [14.5, 2.2, 4.5],
    summary: "Un centro de control: muro de pantallas, estaciones pegadas a la pared y vitrinas con figuras de acción.",
    body: "La pared del fondo está cubierta de pantallas, como el centro de control de Donatello. A los lados, mesas de cómputo pegadas a la pared con monitores negros, teclados y mouse, y sobre ellas vitrinas delgadas con figuras de acción de las tortugas.",
    items: ["Muro de 15 pantallas de control", "Consola central", "Seis estaciones de cómputo", "Vitrinas con figuras de acción"],
  },
  {
    id: "michelangelo", num: "03", name: "Sala Michelangelo", title: "El Taller", dims: "5 m × 3 m", area: 15, color: "#F7923A",
    img: "/img/michelangelo.webp", rect: { x: 17, z: 3, w: 5, d: 3 },
    view: { pos: [19.5, 1.6, HALL_Z], yaw: Math.PI }, pin: [19.5, 2.2, 4.5],
    summary: "Un centro de manualidades: caballetes con lienzos, mesitas de plástico de colores y un gran tapete.",
    body: "Aquí la colección se dibuja y se pinta. Cuatro caballetes de trípode con lienzos, dos mesas infantiles de plástico con pinceles, colores, cuadernos y paletas, y un tapete grande de colores. Todas las paredes están cubiertas de pósters, dibujos y repisas con figuras de acción.",
    items: ["Caballetes con lienzos", "Mesas infantiles de plástico", "Pinceles, colores y cuadernos", "Tapete grande de colores", "Pósters y repisas de figuras"],
  },
  {
    id: "raphael", num: "04", name: "Sala Raphael", title: "El Dojo", dims: "5 m × 3 m", area: 15, color: "#EF5A48",
    img: "/img/raphael.webp", rect: { x: 22, z: 3, w: 5, d: 3 },
    view: { pos: [24.5, 1.6, HALL_Z], yaw: Math.PI }, pin: [24.5, 2.2, 4.5],
    summary: "Un dojo con tatami, las armas de las tortugas empotradas en la pared, pergaminos y vitrinas llenas de juguetes.",
    body: "En la pared del fondo, cuatro nichos iluminados guardan las armas de cada tortuga: katanas, bo, nunchakus y sais. A la derecha cuelgan pergaminos verticales con los valores del dojo, y a la izquierda dos vitrinas de piso a techo llenas de figuras y vehículos. Tatami rojo y azul, y sacos de golpeo junto a la entrada.",
    items: ["Armas empotradas en nichos", "Pergaminos verticales", "Vitrinas de juguetes", "Tatami bicolor", "Sacos de golpeo"],
  },
  {
    id: "cineteca", num: "05", name: "Cineteca", title: "La Proyección", dims: "3 m × 6 m", area: 18, color: "#E8B04A",
    img: "/img/cineteca.webp", rect: { x: 27, z: 0, w: 3, d: 6 },
    view: { pos: [28.5, 1.6, 0.8], yaw: Math.PI }, pin: [28.5, 2.5, 3.8],
    summary: "Filas de butacas frente a la pantalla y carteles originales en los muros.",
    body: "El final del recorrido. Proyecciones, funciones especiales y una colección de carteles enmarcados sobre el ladrillo. Cruza el último arco y apaga las luces.",
    items: ["Butacas de cine", "Pantalla de proyección", "Carteles de colección", "Funciones especiales"],
  },
];

export const roomById = (id) => ROOMS.find((r) => r.id === id);

export const useRooms = () => {
  const { lang } = useLang();
  return useMemo(() => ROOMS.map((r) => locById(r, ROOMS_TR, lang)), [lang]);
};

export const locRoom = (room, lang) => locById(room, ROOMS_TR, lang);

export const roomAt = (x, z) =>
  ROOMS.find((r) => x >= r.rect.x && x <= r.rect.x + r.rect.w && z >= r.rect.z && z <= r.rect.z + r.rect.d) ?? null;

export const START = { pos: [2.6, 1.6, 0.5], yaw: Math.PI * 1.3 };
